var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7207 15C21.151 15.0004 21.5 15.3397 21.5 15.7578V17.2119C21.4999 19.3034 19.7545 20.9997 17.6016 21H6.39844C4.24541 20.9998 2.50011 19.3035 2.5 17.2119V15.7578C2.5 15.3396 2.84886 15.0003 3.2793 15C3.70996 15 4.05957 15.3394 4.05957 15.7578V17.2119C4.05968 18.4668 5.10674 19.4851 6.39844 19.4854H17.6016C18.8932 19.485 19.9403 18.4667 19.9404 17.2119V15.7578C19.9404 15.3394 20.29 15 20.7207 15ZM12.001 4.25C12.4152 4.25 12.751 4.58579 12.751 5V13.0547L15.582 10.2236C15.8748 9.93093 16.3497 9.93113 16.6426 10.2236C16.9354 10.5165 16.9354 10.9913 16.6426 11.2842L12.54 15.3857C12.5295 15.3967 12.5181 15.4067 12.5068 15.417C12.4866 15.4355 12.466 15.4528 12.4443 15.4688C12.3199 15.5606 12.1675 15.6172 12.001 15.6172C11.8336 15.6171 11.6804 15.5605 11.5557 15.4678C11.5354 15.4527 11.5161 15.4363 11.4971 15.4189C11.485 15.4079 11.4723 15.3976 11.4609 15.3857L7.35938 11.2842C7.06684 10.9913 7.0666 10.5164 7.35938 10.2236C7.65215 9.93093 8.12702 9.93113 8.41992 10.2236L11.251 13.0547V5C11.251 4.58588 11.5869 4.25016 12.001 4.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDownloadIcon);
export default __webpack_public_path__ + "static/media/mobile-download-icon.724197cec8e2a46fa490b380288a7e89.svg";
export { ForwardRef as ReactComponent };